<template>
  <div class="app-main-content policy-home-page">
    <div class="grid-view">
      <div class="main-content">
        <div style="width: 70%;margin-left:12%">
          <h1>{{ $t('Insurance.LiabilityInsurance') }}</h1>
          <hr style="border: 1px solid black;">
          <!--服务商-->
          <el-row :gutter="22">
            <el-col style="margin-left: 20px" :span="2"><h3>{{ $t('SystemMaintenance.ServiceProviders') }}</h3></el-col>
            <div v-for="(item, index) in serviceProviders" :key="index">
              <el-col class="title-col" style="text-align: center" :span="7">
                <img :src="imgAgentIcon(item)" width="80%" height="8%">
              </el-col>
            </div>
          </el-row>
          <!--产品价值-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.ProductValue') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                有助于降低业务经营风险、提高企业品牌、形象和信誉;有助于承接优质客户业务，助推企业发展;
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                1、物流责任保险可以为客户提供经营第三方物流业务过程中的全面保障，是一种契合现代物流业发展潮流的新型保险产品。<br>
                2、物流责任保险的责任范围包括在经营物流业务过程中依法应由被保险人承担赔偿责任的物流货物的损失。它将运输中承运人的责任以及仓储、流通加工过程中保管人及加工人的责任融合在一起。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                一、领航与国际知名再保公司联合开发的独家产品；<br>
                二、承保对象：国际货代本身及其合法的代理人<br>
                三、责任期间：从货代接收货物到收货人收到货物所有掌控货物期间的全程责任
              </el-col>
            </div>
          </el-row>
          <!--收费标准-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.Charges') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                <center>
                  3000USD起
                </center>
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                <center>
                  0.1%起，最低3000RMB
                </center>
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                保费和预估今年营业收入以及选择的各项赔偿限额挂钩，一单一议，费率低至千分之1，最低保费是17000人民币，年度保费在3-10万人民币不等
              </el-col>
            </div>
          </el-row>
          <!--询价-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('SeaExport.Operation') }}</h3></el-col>
            <el-col class="page-col" style="text-align: center" :span="7">
              <el-button type="primary" size="medium" @click="toInquiry('xnhb')">{{ $t('Insurance.Inquire') }}</el-button>
            </el-col>
            <el-col class="page-col" style="text-align: center" :span="7">
              <el-button type="primary" size="medium" @click="toInquiry('htjj')">{{ $t('Insurance.Inquire') }}</el-button>
            </el-col>
            <el-col class="page-col" style="text-align: center" :span="7">
              <el-button type="primary" size="medium" @click="toInquiry('lhb')">{{ $t('Insurance.Inquire') }}</el-button>
              <!--              <p style="font-size: 14px;font-weight: bold">供应商陆续上新中...</p>-->
            </el-col>
          </el-row>
          <!--服务优势-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.ServiceAdvantages') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                依据客户实际情况定制保险产品<br>
                多家供应商询价，客户可选择最优方案且有经纪人给出专业建议<br>
                全流程服务专业把关，真正实现买的放心，赔的省心
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                1、保险产品：提供行业内量身定制适用于企业的保险方案。<br>
                2、理赔服务：自有全资保险公估子公司协助客户进行保险索赔、残值处理等全方位服务；英国劳合社在中国大陆指定的独家代理人。<br>
                3、费率浮动机制：为每一个客户提供费率浮动机制“降本增效”。<br>
                4、培训服务：不定期组织线上事故预防服务培训。<br>
                5、风险提示：实时推送政策信息、风险预警信息。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                <center>
                  费率同类险种市场低，保障范围全
                </center>
              </el-col>
            </div>
          </el-row>
          <h1>{{ $t('Insurance.Scanning') }}</h1>
          <hr style="border: 1px solid black;">
          <!--保险公司-->
          <el-row :gutter="22">
            <el-col style="margin-left: 20px" :span="2"><h3>{{ $t('Insurance.InsuranceCompany') }}</h3></el-col>
            <div v-for="(item, index) in serviceProviders" :key="index" style="margin-top: 8px;" :item="item">
              <el-col class="title-col" :span="7">
                <div style="width: 100%;text-align: center">
                  <img v-if="item !== 'lhb'" :src="imgIcon('tpybx')" width="42%" height="3%" style="margin-right: 5px">
                  <img :src="imgIcon('zgpa')" width="42%" height="3%">
                  <br>
                  <img v-if="item !== 'lhb'" :src="imgIcon('zgrb')" width="42%" height="3%" style="margin-right: 5px">
                  <img v-if="item !== 'lhb'" :src="imgCompanyIcon(item)" width="42%" height="3%">
                </div>
              </el-col>
            </div>
          </el-row>
          <!--保险范围-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.InsuranceCoverage') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                货物损坏：货物挤压变形、湿损、坠地、温控货物变质、偷窃盗抢、丢失、共同海损等。<br>
                错误与疏忽：具体包括无单放货、货物错运提单遗失、单证错误、目的地错误、合同履行过失等。<br>
                第三者责任：具体包括第三方人伤、货损、环境污染、第三方运输工具损害等。<br>
                罚款、关税及其他费用：境内外无人提货、目的港弃货海关查验、检验检疫、法律抗辩、追偿、罚金等费用。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                在本保险期间，被保险人在经营物流业务过程中，由于下列原因造成物流货物的损失，依法应由被保险人承担赔偿责任的，保险人根据本保险合同的约定负责赔偿：<br>
                (一)火灾、爆炸；<br>
                (二)运输工具发生碰撞、出轨、倾覆、坠落、搁浅、触礁、沉没，或隧道、桥梁、码头坍塌；<br>
                (三)碰撞、挤压导致包装破裂或容器损坏；<br>
                (四)符合安全运输规定而遭受雨淋；<br>
                (五)装卸人员违反操作规程进行装卸、搬运。<br>
                赔偿限额：根据客户年运量规模 累计赔偿限额 1000万-2000万 每次事故赔偿限额100-200万
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                保障货代企业员工操作引发的责任风险，包括装柜、仓储、订舱、报关、目的港提货等，保障范围分为三大块：货运及相关责任、错误与疏忽、无单放货，无人提货/弃货、第三者责任
              </el-col>
            </div>
          </el-row>
          <!--免赔额-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.Deductible') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                按约定
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                每起事故RMB6000起
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                1.5万人民币
              </el-col>
            </div>
          </el-row>
          <!--赔偿限额-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.MaximumIndemnityNorm') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                货损及相关责任单次限额RMB1,000,000<br>
                全年累计RMB1,000,000；<br>
                错误与疏忽单次限额RMB1,000,000，<br>
                全年累计RMB1,000,000；<br>
                第三者责任单次限额RMB1,000,000，<br>
                全年累计RMB1,000,000；<br>
                关税、罚款及其它费用单次限额RMB1,000,000，<br>
                全年累计RMB1,000,000；<br>
                （单次限额/全年累计RMB4,000,000）
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                每次事故赔偿限额RMB2,100,000；<br>
                全年累计: RMB7,000,000。<br>
                第三者责任单次: RMB700,000;<br>
                全年累计: RMB2100,000。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                货运及相关责任：80万/100万/150万/200万<br>
                错误与疏忽、无单放货，无人提货/弃货：80万/150万<br>
                第三者责任：20万/35万/50万
              </el-col>
            </div>
          </el-row>
          <!--理赔服务-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.ClaimsService') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                指定案件管理人全程协助理赔，细心指导理赔单证的规范填写。大案、要案指定法律顾问提供专案咨询服务，可在线自主查询理赔进度，线上、线下均可预约理赔培训。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                拥有自己的公估公司；协助客户提供理赔材料，<br>
                跟进理赔流程，完成理赔赔付；<br>
                在全球各地超过100个国家拥有理赔网点。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                由领航保的理赔人员和保险公司对接
              </el-col>
            </div>
          </el-row>
          <!--服务商介绍-->
          <el-row :gutter="22" style="margin-top: 30px">
            <el-col class="left-20-top-8" :span="2"><h3>{{ $t('Insurance.ServiceProviderIntroduction') }}</h3></el-col>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                “小牛货保”致力于为贸易、物流、运输、供应链、跨境电商等行业提供有效的风险管理方案，合理预防、处理与解决各项风险带来的巨大损失。利用物联网、互联网、人工智能、物流跟踪技术，同时联合在线理赔团队、律师团队、全球代理勘查网络、残值回收渠道为广大客户提供一站式风险管控的综合管理平台，让物流风控更安全、更高效、更全面。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                华泰经纪是中国再保险集团下的国有制经纪公司，成立至今已经30年，在保险初期风险识别、保险方案设计、保险理赔上拥有全闭环式服务。下属全资子公司，华泰保险公估有限公司为中国劳合社代理，拥有全球的理赔服务网络，能更好的为客户提供理赔咨询，理赔跟踪和现场查勘等服务。
              </el-col>
            </div>
            <div class="col-style">
              <el-col class="page-col" :span="7">
                领航国际保险经纪有限公司成立于2005年，是经中国银保监会批准的全国性、综合性的保险经纪公司，领航保多年来深耕传统货运险、货代责任险、跨境电商FBA保险、物流责任险、仓储险、集装箱险领域，并携手骏日科技为货代物流企业提供航运资质代办及数据通道发送服务，涵盖FMC资质办理、AMS/ISF/ACI/AFR及上海港等预配舱单发送。未来领航将继续致力于创新各种保险产品服务，全方位满足客户需求。
              </el-col>
            </div>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import htjj from '@/assets/insure/htjj.png'
import xnhb from '@/assets/insure/xnhb.png'
import lhb from '@/assets/insure/lhb.png'
import tpybx from '@/assets/insure/tpybx.png'
import zgpa from '@/assets/insure/zgpa.png'
import zgrb from '@/assets/insure/zgrb.png'
import ygbx from '@/assets/insure/ygbx.png'
import djhs from '@/assets/insure/djhs.jpg'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import kebao from '@/assets/insure/kebao.png'
import { HTJJ, TPYBX, XNHB, ZGPA, ZGRB } from '@/class/cargo/model/parameters/InsuranceConstants'

export default {
  name: 'LiabilityHomePage',
  components: { searchItem },
  data() {
    return {
      loading: false,
      serviceProviders: ['xnhb', 'htjj', 'lhb']
    }
  },
  async created() {
  },
  methods: {
    // 代理图标
    imgAgentIcon(value) {
      if (value === InsuranceConstants.HTJJ.code) {
        return htjj
      } else if (value === InsuranceConstants.XNHB.code) {
        return xnhb
      } else if (value === InsuranceConstants.LHB.code) {
        return lhb
      } else {
        return ''
      }
    },
    // 基本保险公司图标
    imgIcon(value) {
      if (value === InsuranceConstants.TPYBX.code) {
        return tpybx
      } else if (value === InsuranceConstants.ZGPA.code) {
        return zgpa
      } else if (value === InsuranceConstants.ZGRB.code) {
        return zgrb
      } else {
        return ''
      }
    },
    // 不同代理对应保险公司图标
    imgCompanyIcon(value) {
      if (value === InsuranceConstants.XNHB.code) {
        return ygbx
      } else if (value === InsuranceConstants.HTJJ.code) {
        return djhs
      } else {
        return ''
      }
    },
    toInquiry(agent) {
      this.$emit('toInquiry', agent)
    }
  }
}
</script>

<style lang="scss">

.title-col {
  font-size: 24px;
}
.page-col {
  font-size: 14px;
}
.margin-top-8 {
  margin-top: 8px;
}

.col-style {
  font-size: 14px;
  margin-top:20px;
}

.left-20-top-8 {
  margin-left: 20px;
  margin-top: 8px;
}
</style>

